module.exports = __webpack_public_path__ + "static/img/SJ.d6fb6a36.svg";